import { Component } from '@angular/core';
import { RelatorioApresentacaoComponent } from "../relatorio-apresentacao/relatorio-apresentacao.component";

@Component({
  selector: 'app-quanto-custa-apresentacao-wrapper',
  standalone: true,
  imports: [RelatorioApresentacaoComponent],
  template: `
    <app-relatorio-apresentacao
      [subtituloHero]="'Módulo'"
      [tituloHero]="'Quanto custa uma escola pública em condições de qualidade?'"
      [breadcrumb]="'Quanto custa uma escola pública em condições de qualidade?'"
      [breadcrumbColor]="'#7FA6BF'"
      [iconeHero]="'assets/ilustrations/how_much.svg'"
      [corSubtituloHero]="'#D92400'"
      [corTituloHero]="'#D92400'"
      [imagemHero]="'assets/imagens/child-writing.svg'"
      [backgroundHero]="'assets/ilustrations/circles-background-1.png'"
      [textoBotaoHero]="'Acessar simulação'"
      [corBotaoHero]="'transparent'"
      [linkBotaoHero]="'/filtrar-escolas'"
      [corTextoBotaoHero]="'#D92400'"
      [infoTexto]="infoTexts"
      [corSetaHero]="'#D92400'"
    ></app-relatorio-apresentacao>`,
})
export class CustoPorEscolaApresentacaoWrapperComponent {
  infoTexts = [
    {
      html: 'Este módulo apresenta estimativas do orçamento da despesa necessária para financiar o Padrão de Qualidade de Referência (PQR) em cada escola pública estadual e/ou municipal, além do Valor aluno CAQ/mês. Também apresenta os dados de matrícula e o número de turmas, funcionários e docentes existentes e projetados com base no PQR, permitindo a contextualização dos resultados. <br><br>' +
        'É fundamental considerar que resultados são determinados pelos parâmetros que compõem o PQR e que estes são aplicados aos dados de oferta de cada uma das escolas públicas estaduais e municipais contidas no recorte territorial considerado na consulta (Brasil, estado ou município). Portanto, no SimCAQ, a escola é a unidade de análise dos custos. Veja os parâmetros que compõem o PQR 2025 (Disponível em <a href="/pqr" class="text-orange-400" style="text-decoration: underline; cursor: pointer;">simcaq.ufg.br/pqr</a>).',
      color: '#444'
    },
    {
      html: 'As informações deste relatório são fundamentais para que o planejamento orçamentário de uma rede pública compreenda que os diferentes contextos e organização da oferta de ensino podem ser fatores intervenientes para o financiamento da educação em condições de qualidade.<br><br>' +
        'Este conjunto de informações está disposto em uma planilha que pode ser baixada. Clique <a href="https://simcaq.ufg.br/assets/20240705_dicionario_variaveis_rel_4.xlsx" class="text-orange-400" style="text-decoration: underline; cursor: pointer;">aqui</a> para acessar o dicionário de variáveis da planilha de dados.<br><br>' +
        'Para realizar uma consulta, siga as seguintes etapas:<br><br>' +
        "1. Selecione o escopo da consulta (Brasil, Estado, Município ou Escola);<br>" +
        '2. Clique no botão “Download dos dados de cada escola (em CSV)”.',
      color: '#444'
    }
  ]
}
